<template>
  <div>
    <el-card class="ele-card">
      <div class="control">
        <label class="label inline-block ">抓取人</label>
        <el-select v-model="selectOperation" filterable clearable placeholder="请选择">
          <el-option
          v-for="item in operationUsers"
          :key="item.userId"
          :label="item.username"
          :value="item.userId">
          </el-option>
        </el-select>
      </div>
      <div class="control">
        <label class="label inline-block ">淘宝店铺</label>
        <el-select v-model="selectShop" filterable clearable remote :remote-method="getShopList" :loading="loading" placeholder="请选择">
          <el-option
            v-for="item in shopList"
            :key="item.shopId"
            :label="item.name"
            :value="item.shopId">
          </el-option>
        </el-select>
      </div>
      <div class="control">
        <label class="label inline-block ">状态</label>
        <el-select v-model="status" clearable placeholder="请选择">
          <el-option key="0" label="待抓取" value="0"></el-option>
          <el-option key="1" label="抓取中" value="1"></el-option>
          <el-option key="2" label="抓取成功" value="2"></el-option>
          <el-option key="3" label="抓取失败" value="3"></el-option>
        </el-select>
      </div>
      <div class="control">
        <label class="label inline-block ">商品名称</label>
        <el-input placeholder="请输入内容" v-model="goodsName" clearable class='width-auto'></el-input>
      </div>
      <div class="control">
        <label class="label inline-block ">平台</label>
        <el-select v-model="platform" multiple clearable placeholder="请选择">
          <el-option key="1" label="淘宝" value="1"></el-option>
          <el-option key="2" label="天猫" value="2"></el-option>
          <el-option key="3" label="蘑菇街" value="3"></el-option>
        </el-select>
      </div>
      <el-button type="primary fright" @click='search'>搜索</el-button>
    </el-card>
    <el-card class="ele-card clearfix">
      <div class='button-wrap'>
        <el-button type="primary" size="small" @click="batchFetch">批量重抓</el-button>
        <el-button type="danger" size="small" @click="batchDelete">批量删除</el-button>
        <el-button type="success" size="small" @click='addFetchFormVisible = true'>单款抓取</el-button>
        <el-button type="success" size="small" @click='addShopFormVisible = true'>店铺抓取</el-button>
      </div>
      <el-pagination
        class='fright'
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount">
      </el-pagination>
    </el-card>
    <el-table :data="fetchingGoodsList" @selection-change="handleSelectionChange" stripe ref='table'>
      <el-table-column type="selection" width="55" align='center'></el-table-column>
      <el-table-column prop="date" label="第三方商品" align='center'>
        <template slot-scope="scope">
          <div><a target='_blank' :href="scope.row.taobaoLink">{{scope.row.thirdPartyGoodsId}}</a></div>
          <div>{{scope.row.name}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="date" label="商品图片" align='center'>
        <template slot-scope="scope">
          <popover-image :img='scope.row.image'></popover-image>
        </template>
      </el-table-column>
      <el-table-column prop="shopName" label="淘宝店铺" align='center'></el-table-column>
      <el-table-column prop="stockCount" label="库存" align='center'></el-table-column>
      <el-table-column prop="fetchTime" label="抓取时间" align='center'></el-table-column>
      <el-table-column prop="operationUsername" label="抓取人" align='center'></el-table-column>
      <el-table-column prop="platform" :formatter="formatPlatform" label="平台" align='center'></el-table-column>
      <el-table-column prop="fetchStatus" label="抓取状态" align='center'>
        <template slot-scope="scope">
          <div>{{scope.row.fetchStatus}}</div>
          <div>{{scope.row.fetchErrorMessage}}</div>
        </template>
      </el-table-column>
      <el-table-column label="自动审核" align='center'>
        <template slot-scope="scope">{{scope.row.isAutoVerify ? '开启' : '关闭'}}</template>
      </el-table-column>
      <el-table-column label="审核结果" align='center'>
        <template v-if="scope.row.noVerifyMsg" slot-scope="scope">
          <div>失败</div>
          <div>{{scope.row.noVerifyMsg}}</div>
        </template>
      </el-table-column>
      <el-table-column label="操作" align='center'  width="80">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class='fright bottom-pagination'
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalCount">
    </el-pagination>
    <el-dialog title="新增单款抓取" :visible.sync="addFetchFormVisible" :lock-scroll='false'>
      <el-form :model="form" :rules="rules" label-width="120px">
        <el-form-item label="添加商品地址" prop="thirdPartyGoodsURL">
          <el-input v-model="form.thirdPartyGoodsURL" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="是否自动审核">
          <el-radio v-model="form.isAutoVerify" :label="0">手动</el-radio>
          <el-radio v-model="form.isAutoVerify" :label="1">自动</el-radio>
        </el-form-item>
        <el-form-item label="对应穿衣店铺" prop='cyzsUserId'>
          <el-select v-model="form.cyzsUserId" filterable placeholder="请选择">
            <el-option v-for="item in cyzsShopList" :key="item.userId" :label="item.name" :value="item.userId"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span style='padding-left: 24px;'>开启后商品抓取完成后自动判断必填项目入库</span>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addFetchFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addFetchGoods">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="新增店铺" :visible.sync="addShopFormVisible" :lock-scroll='false'>
      <el-form :model="shopForm" :rules="shopRules" label-width="120px">
        <el-form-item label="平台">
          <el-radio v-model="shopForm.platform" :label="1">淘宝</el-radio>
          <el-radio v-model="shopForm.platform" disabled :label="2">天猫</el-radio>
          <el-radio v-model="shopForm.platform" disabled :label="3">蘑菇街</el-radio>
        </el-form-item>
        <el-form-item label="第三方店铺地址" prop="shopHomeUrl">
          <el-input v-model="shopForm.shopHomeUrl" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="对应穿衣店铺" prop='cyzsUserId'>
          <el-select v-model="shopForm.cyzsUserId" filterable placeholder="请选择">
            <el-option v-for="item in cyzsShopList" :key="item.userId" :label="item.name" :value="item.userId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否自动审核">
          <el-radio v-model="shopForm.isAutoVerify" :label="0">手动</el-radio>
          <el-radio v-model="shopForm.isAutoVerify" :label="1">自动</el-radio>
        </el-form-item>
        <el-form-item label="过滤条件" prop='goodRate'>
          <el-input v-model="shopForm.goodRate" auto-complete="off">
            <template slot="prepend">好评率 ></template>
            <template slot="append">%</template>
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addShopFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addShop">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/babel">
  import { formatDate } from 'UTILS/date';
  import { Message } from 'element-ui';
  import PopoverImage from './popoverImage';
  export default {
    data() {
      return {
        shopRules: {
          shopHomeUrl: [
            { required: true, message: '请输入店铺地址', trigger: 'blur' },
          ],
          cyzsUserId: [
            { required: true, message: '请输入店铺', trigger: 'change' },
          ],
        },
        rules: {
          thirdPartyGoodsURL: [
            { required: true, message: '请输入商品地址', trigger: 'blur' },
          ],
        },
        fetchingGoodsList: [],
        operationUsers: [],
        selectOperation: '',
        shopList: [],
        loading: false,
        cyzsShopList: [],
        selectShop: '',
        status: '',
        goodsName: '',
        platform: '',
        page: 1,
        pageSize: 20,
        totalCount: 0,
        form: {
          thirdPartyGoodsURL: '',
          isAutoVerify: 0,
          cyzsUserId: '',
        },
        shopForm: {
          platform: 1,
          shopHomeUrl: '',
          cyzsUserId: '',
          isAutoVerify: 0,
          goodRate: '',
        },
        selectList: [],
        deleteDialogVisible: false,
        fetchDialogVisible: false,
        addFetchFormVisible: false,
        addShopFormVisible: false,
      }
    },
    components: {
      PopoverImage
    },
    mounted() {
      this.getOperationUsers();
      this.getFetchingGoodsList();
    },
    methods: {
      getFetchingGoodsList() {
        let params = {
          operationUserId: this.selectOperation,
          goodsName: this.goodsName,
          shopId: this.selectShop,
          fetchStatus: this.status,
          platform: this.platform,
          page: this.page,
          pageSize: this.pageSize
        }
        HttpRequest.get('/admin.php?method=shoppingguide.getFetchingGoodsList', params).then((response) => {
          this.totalCount = response.data.count;
          this.fetchingGoodsList = _.toArray(response.data.list).map((item) => {
            item.taobaoLink = `https://item.taobao.com/item.htm?id=${item.thirdPartyGoodsId}`,
            item.fetchTime = formatDate(item.fetchTime, "yyyy-MM-dd hh:mm:ss");
            item.isAutoVerify = item.isAutoVerify == 1;
            item.fetchStatus = item.fetchStatus == 0 ? '待抓取' : item.fetchStatus == 1 ? '抓取中' : item.fetchStatus == 2 ? '抓取成功' : '抓取失败'
            return item;
          });
          if (this.cyzsShopList.length == 0) {
            this.getCyzsShopList();
          }
        })
      },
      search() {
        this.page = 1;
        this.getFetchingGoodsList();
      },
      batchFetch() {
        if (this.selectList.length == 0) {
          Message({ type: 'info', message: '请勾选商品' });
          return;
        }
        this.$confirm('请确认：当前选中商品重新抓取，已成功商品不再进行抓取，入库后每天会定时更新', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let params = this.selectList.map((item) => {
            return { thirdPartyGoodsId: item.thirdPartyGoodsId, platform: item.platform }
          })
          HttpRequest.post('/admin.php?method=shoppingguide.doFetching', { goodsIndexes: params }).then((response) => {
            this.$refs.table.clearSelection();
            Message({ type: 'success', message: '操作成功!' });
          }).catch(() => {
            Message({ type: 'info', message: '操作失败' });
          })
        }).catch(() => {
          Message({ type: 'info', message: '已取消操作' });
        });
      },
      batchDelete() {
        if (this.selectList.length == 0) {
          Message({ type: 'info', message: '请勾选商品' });
          return;
        }
        this.$confirm('请确认：删除当前页面勾选商品数据?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let params = this.selectList.map((item) => {
            return { thirdPartyGoodsId: item.thirdPartyGoodsId, platform: item.platform }
          })
          HttpRequest.post('/admin.php?method=shoppingguide.doRemoveGoods', { goodsIndexes: params }).then(() => {
            this.getFetchingGoodsList();
          })
          Message({ type: 'success', message: '操作成功!' });
        }).catch(() => {
          Message({ type: 'info', message: '已取消操作' });
        });
      },
      handleEdit(value) {
        window.open(`/adminv/#!/thirdGoods/addGoods?hasMultiPrice=${value.hasMultiPrice}&platform=${value.platform}&thirdPartyGoodsId=${value.thirdPartyGoodsId}`)
      },
      handleDelete(index, data) {
        this.$confirm('请确认：删除当前商品数据?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          HttpRequest.get('/admin.php?method=shoppingguide.doRemoveGoods', { thirdPartyGoodsId: data.thirdPartyGoodsId, platform: data.platform })
          this.fetchingGoodsList.splice(index, 1)
          Message({ type: 'success', message: '操作成功!' });
        }).catch(() => {
          Message({ type: 'info', message: '已取消操作' });
        });
      },
      getOperationUsers() {
        HttpRequest.get('/admin.php?method=shoppingguide.getOperationUsers').then((response) => {
          this.operationUsers = _.toArray(response.data)
        })
      },
      getShopList(query) {
        if (query !== '') {
          this.loading = true;
          setTimeout(() => {
            this.loading = false;
            HttpRequest.get('/admin.php?method=shoppingguide.getShopList', {keyword: query}).then((response) => {
              this.shopList = _.toArray(response.data.list)
            })
          }, 500);
        } else {
          this.shopList = [];
        }
      },
      getCyzsShopList() {
        HttpRequest.get('/admin.php?method=Thirdpartybusinessuser.getSimpleList').then((response) => {
          this.cyzsShopList = _.toArray(response.data)
        })
      },
      addFetchGoods() {
        if (this.form.thirdPartyGoodsURL) {
          if (this.form.isAutoVerify == 1 && !this.form.cyzsUserId) {
             Message({ type: 'info', message: '请选择对应的穿衣店铺' });
          } else {
            HttpRequest.get('/admin.php?method=shoppingguide.doAddGoods', this.form).then(() => {
              Message({ type: 'success', message: '操作成功!' });
              this.form = {
                thirdPartyGoodsURL: '',
                isAutoVerify: 0,
                cyzsUserId: '',
              }
              setTimeout(() => {
                this.page = 1;
                this.getFetchingGoodsList();
              }, 1500)
            })
            this.addFetchFormVisible = false;
          }
        } else {
          Message({ type: 'info', message: '请填写商品地址' });
        }
      },
      addShop() {
        if (this.shopForm.shopHomeUrl && this.shopForm.cyzsUserId) {
          HttpRequest.get('/admin.php?method=thirdpartybusinessuser.doAddShop', this.shopForm).then(() => {
            this.shopForm = {
              platform: 1,
              shopHomeUrl: '',
              cyzsUserId: '',
              isAutoVerify: 0,
              goodRate: '',
            }
            Message({ type: 'success', message: '操作成功!' });
          })
          this.addShopFormVisible = false;
        } else {
          Message({ type: 'info', message: '请填写必填项' });
        }
      },
      handleSelectionChange(value) {
        this.selectList = value;
      },
      handleSizeChange(value) {
        this.pageSize = value;
        this.getFetchingGoodsList();
      },
      handleCurrentChange(value) {
        this.page = value;
        this.getFetchingGoodsList();
      },
      formatPlatform(row, column, cellValue, index) {
        return cellValue == 1 ? '淘宝' : cellValue == 2 ? '天猫' : '蘑菇街';
      }
    }
  }
</script>

<style lang="less" scoped>
.el-button+.el-button {
  margin-left: 0;
  margin-top: 10px;
}
.width-auto {
  width: auto;
}
.ele-card {
    margin-bottom: 10px;
}
.button-wrap {
  display: inline-block;
}
.center {
  text-align: center;
}
.bottom-pagination {
  margin: 20px 0;
}
</style>
